import { PlanModelInfo, planTypes } from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';

const zdocsCategory = {
  zoom_docs: {
    typeNameKey: 'billing.zoom_docs.title',
    planNameKey: 'billing.zoom_docs.title'
  }
};

export default (planMapJSON = {}) => {
  const cycleDepList = []

  return Object.keys(zdocsCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.ZOOM_DOCS).map(item => ({
        ...item,
        ...zdocsCategory[key],
        billingCycleDependBasePlanTypeList: cycleDepList,
        standAlone: true,
        unit: planUnitMap.license,
        planModel: PlanModelInfo.license
      })),
      ...pre,
    ];
  }, []);
}



